import { ChartData, ScaleOptions, TooltipItem } from 'chart.js';
import { linesColorArray } from '@config/colors';
import { IChartDataPoint } from '@types';

export const footer = (tooltipItems: TooltipItem<'line'>[]) => {
    let sum = 0;
    tooltipItems.forEach(tooltipItem => {
        sum += tooltipItem.parsed.y;
    });
    return 'Сумма: ' + new Intl.NumberFormat('ru-RU').format(sum);
};

export const yScale: ScaleOptions<'linear'> = {
    beginAtZero: true,
    suggestedMin: 0,
};

export const generateChartData = (
    range: string[],
    values: IChartDataPoint[],
    hiddenDatasets: number[]
): ChartData<'line', number[], string> => ({
    labels: range,
    datasets: values?.map((item, ind) => ({
        label: item?.key,
        data: item?.values,
        borderColor: linesColorArray[ind]?.borderColor,
        backgroundColor: linesColorArray[ind]?.backgroundColor,
        fill: false,
        spanGaps: false,
        hidden: hiddenDatasets.includes(ind),
    })),
});
export const generateAbcChartData = (
    ranges: string[],
    values: number[],
    hiddenDatasets: number[]
) => ({
    labels: ranges,
    datasets: values?.map((item, ind) => ({
        label: ranges ? ranges[ind] : '',
        data: [item],
        borderColor: linesColorArray[ind]?.borderColor,
        backgroundColor: linesColorArray[ind]?.backgroundColor,
        fill: false,
        spanGaps: false,
        borderRadius: 6,
        barThickness: 12,
        hidden: hiddenDatasets.includes(ind),
    })),
});
